export default __webpack_public_path__ + "6d78296bc1827781055ad574af4a4084.png";